<template>
  <div class="h-full bg-skin-sidebar w-full 1xl:w-xs px-35 text-skin-secondary">
    <UserProfileSettings
      class="mx-auto mt-40px cursor-pointer border-2	border-white	"
      :name="first_name.charAt(0)"
      :lname="last_name.charAt(0)"
      :imageData="imagen"
    />
    <p class="text-l text-center font-bold capitalize	 my-40px">
      {{ first_name }} {{ last_name }}
    </p>

    <p class="font-bold text-m pb-m text-skin-darkgray">
      Bienvenido a tu perfil de usuario
    </p>

    <p class="text-m border-b pb-m border-gray-400">
      Aquí podras realizar modificaciones en cuanto a tu perfil.
    </p>

    <p
      class="py-m border-b pb-m border-gray-400 font-bold text-m pb-m text-skin-dargray"
    >
      En {{ GET_PROJECT.name }} desde {{ month }} del {{ year }}
    </p>

    <p class="font-bold text-m py-m text-skin-dargray">
      Tienes {{total_active_courses}} cursos disponibles
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserProfileSettings from "./UserProfileSettings.vue";
export default {
  components: {
    UserProfileSettings,
  },
  props: {
    first_name: {
      type: String,
      required: true,
    },
    last_name: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    total_active_courses:{
      type: Number,
      required: true
    },
    imagen:{
      default: ''
    }
  },
  data() {
    return {
      month: "",
      year: "",
    };
  },
  mounted() {
    const unixTimestamp = Date.parse(this.date);

    const dateObject = new Date(unixTimestamp);

    this.month = dateObject.toLocaleString("es-VE", { month: "long" });
    this.year = dateObject.toLocaleString("en-US", { year: "numeric" });
  },
  methods: {
    chooseFiles() {
      this.$refs.fileInput.click();
    },
  },
  computed: {
    ...mapGetters("project", ["GET_PROJECT"]),
  },
};
</script>
